import React from 'react';
import { ProvisionProfiles } from '../components';

export default () => {
    return (
        <ProvisionProfiles.Home />
    )
}